export default __webpack_public_path__ + "static/media/medium.6ced613d.svg";